import React from "react";

const RequiredMark = () => {
  return <span className="requiredField">*</span>;
};

export default RequiredMark;
